import { useWatch } from 'react-hook-form';
import { AccessForm, EditValues } from '../../../Interfaces/admin/Role.interfaces';
import { RegisterFormFields } from './RegisterForm';

type ReportIconsProps = {
  showNotification: boolean;
  showEdit: boolean;
  showApproval: boolean;
  iconClassName: string;
  optionIndex: number;
  defaultEdit?: EditValues;
};

const ReportIcons = ({
  showApproval,
  showEdit,
  showNotification,
  iconClassName,
  optionIndex,
  defaultEdit,
}: ReportIconsProps) => {
  const option = useWatch<RegisterFormFields>({
    name: `access.${optionIndex}`,
  }) as AccessForm;

  const getEditIcon = (value?: EditValues) => {
    const defaultStyles = `${iconClassName} text-bluwaiBlue`;
    const eyeIcon = (
      <i
        className={`pi pi-eye text-gray-400 ${iconClassName}`}
        data-pr-position="bottom"
        data-pr-tooltip="View only"
      />
    );

    if (typeof value === 'boolean') {
      return value ? (
        <i
          className={`pi pi-file-edit ${defaultStyles}`}
          data-pr-position="bottom"
          data-pr-tooltip="Can create/upload (depends on the report)"
        />
      ) : (
        eyeIcon
      );
    }

    switch (value) {
      case 'approval':
        return (
          <span
            className={`relative ${defaultStyles}`}
            data-pr-position="bottom"
            data-pr-tooltip="Can create drafts but needs approval to upload"
          >
            <i className="pi pi-file" />
            <i className="pi pi-check absolute text-7px bottom-20 left-0 ml-1 font-bold" />
          </span>
        );
      case 'no-approval':
        return (
          <span
            className={`relative ${defaultStyles}`}
            data-pr-position="bottom"
            data-pr-tooltip="Can create drafts and upload without approval"
          >
            <i className="pi pi-file" />
            <i className="pi pi-arrow-up absolute text-7px bottom-20 left-0 ml-1 font-bold" />
          </span>
        );
      default:
        return eyeIcon;
    }
  };

  return (
    <div className="ml-5 flex gap-3 align-items-center">
      {showNotification && (
        <i
          className={`pi pi-bell ${iconClassName} ${
            option.shouldNotify ? 'text-yellow-600' : 'text-gray-400'
          }`}
          data-pr-position="bottom"
          data-pr-tooltip={
            option.shouldNotify
              ? 'Will receive notifications'
              : `Won't receive notifications`
          }
        />
      )}
      {showEdit && getEditIcon(option.editable ?? defaultEdit)}
      {showApproval && (
        <i
          className={`pi pi-check-square ${iconClassName} ${
            option.shouldApprove ? 'text-green-500' : 'text-gray-400'
          }`}
          data-pr-position="bottom"
          data-pr-tooltip={
            option.shouldApprove ? 'Can approve drafts' : "Can't approve drafts"
          }
        />
      )}
    </div>
  );
};

export default ReportIcons;
